import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardHeader,
  CardBody
} from "reactstrap";
import * as moment from "moment";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const ModalExportacaoAvancada = ({
  isOpen,
  toggle,
  data,
  feiraNome = "Relatório Geral",
  statusOptions
}) => {
 
  const camposDisponiveis = [
    { id: 'feira', label: 'Feira', accessor: 'feira.nome' },
    { id: 'estande', label: 'Espaço', accessor: 'estande.nome' },
    { id: 'expositor', label: 'Expositor', accessor: 'expositor.nome' },
    { id: 'pavilhao', label: 'Pavilhão', accessor: 'pavilhao.nome' },
    { id: 'vendedor', label: 'Vendedor', accessor: 'comercial.nome' },
    { id: 'status', label: 'Status', accessor: item => item.etapas?.[item.etapas.length - 1]?.etapa_reserva?.nome || '--' },
    { id: 'valido_ate', label: 'Válido até', accessor: 'reserva_valida_ate' },
    { id: 'solicitado_em', label: 'Solicitado em', accessor: 'created_at' },
    { id: 'atualizado_em', label: 'Atualizado em', accessor: 'updated_at' },
    { id: 'forma_pagamento', label: 'Forma de Pagamento', accessor: 'forma_pagamento.nome' },
    { id: 'condicao_pagamento', label: 'Condição de Pagamento', accessor: 'condicao_pagamento.nome' }
  ];

  // Estado para controle do modal
  const [camposSelecionados, setCamposSelecionados] = useState([
    'feira', 'estande', 'expositor', 'vendedor', 'status', 'valido_ate'
  ]);
  const [ordenacao, setOrdenacao] = useState('atualizado_em');
  const [ordemDescendente, setOrdemDescendente] = useState(true);

  // Função para alternar seleção de campo
  const toggleCampo = (campoId) => {
    if (camposSelecionados.includes(campoId)) {
      setCamposSelecionados(camposSelecionados.filter(id => id !== campoId));
    } else {
      setCamposSelecionados([...camposSelecionados, campoId]);
    }
  };

  // Função para ordenar os dados
  const ordenarDados = (dados) => {
    return [...dados].sort((a, b) => {
      let valorA, valorB;
      
      switch (ordenacao) {
        case 'atualizado_em':
          valorA = new Date(a.updated_at).getTime();
          valorB = new Date(b.updated_at).getTime();
          break;
        case 'estande':
          valorA = a.estande?.nome || '';
          valorB = b.estande?.nome || '';
          break;
        case 'vendedor':
          valorA = a.comercial?.nome || '';
          valorB = b.comercial?.nome || '';
          break;
        default:
          return 0;
      }
      
      if (typeof valorA === 'string') {
        return ordemDescendente 
          ? valorB.localeCompare(valorA)
          : valorA.localeCompare(valorB);
      } else {
        return ordemDescendente ? valorB - valorA : valorA - valorB;
      }
    });
  };

  const gerarPDF = () => {
    
    if (!data || data.length === 0) {
      alert("Nenhum dado disponível para exportar");
      return;
    }

    const doc = new jsPDF({
      unit: 'mm',
      format: 'a4',
      compress: true
    });

    const margin = 10;
    const pageWidth = doc.internal.pageSize.getWidth();
    const primaryColor = [54, 54, 54 ];
    const secondaryColor = [79, 79, 79];

    const setHeaderStyle = () => {
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...primaryColor);
    };

    const setBodyStyle = () => {
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...secondaryColor);
    };

    setHeaderStyle();
    doc.setFontSize(16);
    doc.text('RELATÓRIO DE RESERVAS', pageWidth / 2, 15, { align: 'center' });

    setBodyStyle();
    doc.setFontSize(10);
    doc.text(`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`, pageWidth - margin, 12, { align: 'right' });
    doc.text(`Ordenado por: ${camposDisponiveis.find(c => c.id === ordenacao)?.label || ''} ${ordemDescendente ? '(Decrescente)' : '(Crescente)'}`, margin, 22);

    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(margin, 25, pageWidth - margin, 25);

    const camposExportar = camposDisponiveis.filter(campo => 
      camposSelecionados.includes(campo.id)
    );

    const dadosOrdenados = ordenarDados(data);

    const tableData = dadosOrdenados.map(item => {
      return camposExportar.map(campo => {
        let value;
        
        if (typeof campo.accessor === 'function') {
          value = campo.accessor(item);
        } else if (campo.accessor.includes('.')) {
          const keys = campo.accessor.split('.');
          value = keys.reduce((obj, key) => obj?.[key] || '--', item);
        } else {
          value = item[campo.accessor] || '--';
        }

        if (['reserva_valida_ate', 'created_at', 'updated_at'].includes(campo.id)) {
          return value !== '--' ? moment(value).format('DD/MM/YYYY HH:mm') : value;
        }
        
        return value;
      });
    });

    autoTable(doc, {
      startY: 30,
      head: [camposExportar.map(campo => campo.label)],
      body: tableData,
      margin: { left: margin, right: margin },
      headStyles: {
        fillColor: primaryColor,
        textColor: 255,
        fontSize: 9,
        cellPadding: 2
      },
      bodyStyles: {
        fontSize: 8,
        cellPadding: 2,
        lineWidth: 0.1
      },
      columnStyles: {
        ...(camposExportar.some(c => ['reserva_valida_ate', 'created_at', 'updated_at'].includes(c.id)) && {
          [camposExportar.findIndex(c => ['reserva_valida_ate', 'created_at', 'updated_at'].includes(c.id))]: {
            cellWidth: 25,
            halign: 'right'
          }
        }
    )},
      styles: {
        overflow: 'linebreak',
        lineColor: [200, 200, 200],
        lineWidth: 0.1
      }
    });

    let finalY = doc.lastAutoTable.finalY || 40;
    let yPosition = finalY + 10;
    
    if (yPosition > 250) { // Adiciona nova página se não houver espaço
        doc.addPage();
        yPosition = 20;
    }
    
    setHeaderStyle();
    doc.setFontSize(12);
    doc.text('TOTALIZADOR POR STATUS', margin, yPosition);
    yPosition += 8;
    
    const statusCount = {};
    statusOptions.forEach(status => {
      statusCount[status] = dadosOrdenados.filter(item => {
        const etapas = item.etapas || [];
        const ultimaEtapa = etapas[etapas.length - 1]?.etapa_reserva?.nome || "";
        return ultimaEtapa === status;
      }).length;
    });

    const labelWidth = 50;
    const valuePosition = margin + labelWidth + 5;
    const lineHeight = 6;

    setBodyStyle();
    doc.setFontSize(10);
    
    statusOptions.forEach(status => {
      doc.setFont('helvetica', 'bold');
      doc.text(`${status}:`, margin, yPosition);
      
      doc.setFont('helvetica', 'normal');
      doc.text(statusCount[status].toString(), valuePosition, yPosition);
      
      yPosition += lineHeight;
    });

    yPosition += 2;
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    doc.text('TOTAL GERAL:', margin, yPosition);
    doc.text(dadosOrdenados.length.toString(), valuePosition, yPosition);

    // ========================================================================
    // === INÍCIO DA NOVA SEÇÃO DE TOTALIZADOR GERAL (BASEADO NA IMAGEM) ===
    // ========================================================================

    yPosition += 15; // Espaçamento maior para a nova seção

    if (yPosition > 220) { // Adiciona nova página se não houver espaço
        doc.addPage();
        yPosition = 20;
    }

    // --- 1. Cálculos das Métricas ---
    const totalEspacos = dadosOrdenados.length;
    // Assumindo que estande.metragem_total e estande.valor_total existem nos seus dados
    const metragemTotal = dadosOrdenados.reduce((sum, item) => sum + (item.estande?.metragem_total || 0), 0);
    const valorTotalVend = dadosOrdenados.reduce((sum, item) => sum + (item.estande?.valor_total || 0), 0);
    
    // Filtros específicos para Chapecó
    const dadosChapeco = dadosOrdenados.filter(item => item.expositor?.cidade === 'Chapecó');
    const clientesChapeco = dadosChapeco.length;
    const metragemChapeco = dadosChapeco.reduce((sum, item) => sum + (item.estande?.metragem_total || 0), 0);
    const valorChapeco = dadosChapeco.reduce((sum, item) => sum + (item.estande?.valor_total || 0), 0);

    // Funções de formatação
    const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    const formatNumber = (value) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    const formatPercentage = (part, total) => total > 0 ? `${formatNumber((part / total) * 100)}%` : '0,00%';
    
    // --- 2. Renderização no PDF ---
    setHeaderStyle();
    doc.setFontSize(12);
    doc.text('RESUMO GERAL', margin, yPosition);
    yPosition += 8;
    
    const col1 = margin;
    const col2 = margin + 50; // Posição para os valores
    const col3 = margin + 80; // Posição para percentuais (se houver)

    setBodyStyle();
    doc.setFontSize(10);

    // Função auxiliar para desenhar linhas no totalizador
    const drawLine = (label, value) => {
      doc.setFont('helvetica', 'bold');
      doc.text(label, col1, yPosition);
      doc.setFont('helvetica', 'normal');
      doc.text(value.toString(), col2, yPosition, { align: 'left' });
      yPosition += lineHeight;
    };
    
    const drawLineWithPercentage = (label, value, percentage) => {
      doc.setFont('helvetica', 'bold');
      doc.text(label, col1, yPosition);
      doc.setFont('helvetica', 'normal');
      doc.text(value.toString(), col2, yPosition, { align: 'left' });
      doc.text(percentage.toString(), col3, yPosition, { align: 'left' });
      yPosition += lineHeight;
    };

    drawLine('Total de Espaços Vendidos', totalEspacos);
    drawLine('Metragem Total Vendida', `${formatNumber(metragemTotal)} m²`);
    drawLine('Valor Total Vendido', formatCurrency(valorTotalVend));
    
    yPosition += 6; // Espaço antes da seção de Chapecó

    // Seção Chapecó
    drawLineWithPercentage('Clientes Chapecó', clientesChapeco, formatPercentage(clientesChapeco, totalEspacos));
    drawLineWithPercentage('M² de Chapecó', `${formatNumber(metragemChapeco)} m²`, formatPercentage(metragemChapeco, metragemTotal));
    drawLineWithPercentage('Valor Total Vendido', formatCurrency(valorChapeco), formatPercentage(valorChapeco, valorTotalVend));
    
    // ========================================================================
    // === FIM DA NOVA SEÇÃO DE TOTALIZADOR GERAL ===
    // ========================================================================

    doc.setFontSize(8);
    doc.setTextColor(100);
    doc.text(`Página ${doc.internal.getNumberOfPages()}`, pageWidth - margin, 285, { align: 'right' });

    doc.save(`relatorio_reservas_${moment().format('YYYYMMDD_HHmm')}.pdf`);
    toggle();
  };

return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Exportação Avançada</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <Card>
              <CardHeader>
                <h5 className="mb-0">Selecione os Campos</h5>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  {camposDisponiveis.map(campo => (
                    <div key={campo.id} className="form-check mb-2">
                      <Input
                        type="checkbox"
                        id={`campo-${campo.id}`}
                        checked={camposSelecionados.includes(campo.id)}
                        onChange={() => toggleCampo(campo.id)}
                      />
                      <Label for={`campo-${campo.id}`} check>
                        {campo.label}
                      </Label>
                    </div>
                  ))}
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          
          <Col md={6}>
            <Card>
              <CardHeader>
                <h5 className="mb-0">Opções de Ordenação</h5>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  <Label for="ordenacao">Ordenar por:</Label>
                  <Input
                    type="select"
                    id="ordenacao"
                    value={ordenacao}
                    onChange={(e) => setOrdenacao(e.target.value)}
                  >
                    <option value="atualizado_em">Data de Atualização</option>
                    <option value="estande">Nome do Espaço</option>
                    <option value="vendedor">Nome do Vendedor</option>
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <div className="form-check">
                    <Input
                      type="checkbox"
                      id="ordemDescendente"
                      checked={ordemDescendente}
                      onChange={() => setOrdemDescendente(!ordemDescendente)}
                    />
                    <Label for="ordemDescendente" check>
                      Ordem Decrescente
                    </Label>
                  </div>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={gerarPDF}>
          Exportar PDF
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalExportacaoAvancada;